window.initPDFViewer = function initPDFViewer(url) {
    let pdfDoc = null;
    let pageNum = 1;
    let pageRendering = false;
    let pageNumPending = null;
    let scale = 1;
    const zoomStep = 0.15;
    const canvas = document.getElementById("pdf-viewer");
    const ctx = canvas.getContext("2d");
    const btnZoomIn = document.getElementById("btn-zoom-in");
    const btnZoomOut = document.getElementById("btn-zoom-out");
    const viewer = document.getElementById("pdf-viewer");

    function renderPage(num) {
        pageRendering = true;

        pdfDoc.getPage(num).then(function (page) {
            const viewport = page.getViewport({ scale });
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            const renderContext = {
                canvasContext: ctx,
                viewport: viewport,
            };

            const renderTask = page.render(renderContext);

            renderTask.promise.then(function () {
                pageRendering = false;

                if (pageNumPending !== null) {
                    renderPage(pageNumPending);
                    pageNumPending = null;
                }
            });
        });

        document.getElementById("page_num").textContent = num;
    }

    function queueRenderPage(num) {
        if (pageRendering) {
            pageNumPending = num;

        } else {
            renderPage(num);
        }
    }

    function onPrevPage() {
        if (pageNum <= 1) {
            return;
        }

        pageNum--;

        viewer.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });

        queueRenderPage(pageNum);
    }

    function onNextPage() {
        if (pageNum >= pdfDoc.numPages) {
            return;
        }

        pageNum++;

        viewer.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });

        queueRenderPage(pageNum);
    }

    function zoomIn() {
        btnZoomOut.removeAttribute('disabled');
        scale += zoomStep;

        if (scale >= 1.75) {
            btnZoomIn.setAttribute('disabled', 'disabled');
        }

        queueRenderPage(pageNum);
    }

    function zoomOut() {
        btnZoomIn.removeAttribute('disabled');
        scale -= zoomStep;

        if (scale <= 0.5) {
            btnZoomOut.setAttribute('disabled', 'disabled');
        }

        queueRenderPage(pageNum);
    }

    document.getElementById("btn-prev").addEventListener("click", onPrevPage);
    document.getElementById("btn-next").addEventListener("click", onNextPage);
    btnZoomIn.addEventListener("click", zoomIn);
    btnZoomOut.addEventListener("click", zoomOut);

    pdfjsLib.getDocument(url).promise.then(function (_pdfDoc) {
        pdfDoc = _pdfDoc;
        document.getElementById("page_count").textContent = pdfDoc.numPages;

        renderPage(pageNum);
    });
}
